// After the_Kit's packages/admin/src/shell/Sidebar.tsx (copied idea: white 224 px column, the Firstfund logo on top,
// upper-case group labels, .nav-item); the menu is the Hub's own (menu.ts), filtered by permission.
import { Link, NavLink } from 'react-router-dom'
import { ExternalLink, X } from 'lucide-react'
import { apiMode } from '@/lib/hubApi'
import { useDevStore } from '@/store/devStore'
import { MENU } from './menu'
import { useCurrentUser } from './useCurrentUser'

export function Sidebar() {
  const { can } = useCurrentUser()
  const open = useDevStore((s) => s.sidebarOpen)
  const setOpen = useDevStore((s) => s.setSidebarOpen)

  return (
    <>
      {open && <div className="fixed inset-0 z-30 bg-black/30 lg:hidden" onClick={() => setOpen(false)} aria-hidden="true" />}
      <aside
        className={`fixed inset-y-0 left-0 z-40 flex w-56 flex-col border-r border-slate-200 bg-white transition-transform dark:border-slate-700 dark:bg-surface-dark lg:static lg:translate-x-0 ${open ? 'translate-x-0' : '-translate-x-full'}`}
        aria-label="Main menu"
      >
        <div className="flex h-12 items-center gap-2 border-b border-slate-200 px-3 dark:border-slate-700">
          {/* The Firstfund logo (owner 2026-10-21; the dark-mode version in dark mode), then the product name. */}
          <Link to="/" className="flex min-w-0 items-center gap-2" aria-label="Firstfund Lender Hub, home">
            <img src="/brand/firstfund-logo-no-descriptor.svg" alt="" className="block h-5 w-auto dark:hidden" />
            <img src="/brand/firstfund-logo-no-descriptor-reversed.svg" alt="" className="hidden h-5 w-auto dark:block" />
            <span className="h-4 w-px shrink-0 bg-slate-200 dark:bg-slate-600" aria-hidden="true" />
            <span className="truncate text-sm font-semibold text-default">Lender Hub</span>
          </Link>
          <button type="button" className="icon-btn ml-auto lg:hidden" onClick={() => setOpen(false)} aria-label="Close menu">
            <X size={16} />
          </button>
        </div>
        <nav className="flex-1 space-y-4 overflow-y-auto px-2 py-3">
          {MENU.map((s) => {
            const items = s.items.filter((i) => !i.permission || can(i.permission))
            if (!items.length) return null
            return (
              <div key={s.label}>
                <div className="px-2.5 pb-1 text-2xs font-bold uppercase tracking-wider text-muted">{s.label}</div>
                <ul className="space-y-0.5">
                  {items.map((i) => (
                    <li key={i.label}>
                      {i.newTab ? (
                        <a href={i.to} target="_blank" rel="noopener" className="nav-item" title="Opens in a new tab">
                          <i.Icon size={14} />
                          {i.label}
                          <ExternalLink size={11} className="ml-auto opacity-60" aria-hidden="true" />
                        </a>
                      ) : (
                      <NavLink
                        to={i.to}
                        end={i.end}
                        className={({ isActive }) => `nav-item ${isActive ? 'nav-item-active' : ''}`}
                        onClick={() => window.innerWidth < 1024 && setOpen(false)}
                      >
                        <i.Icon size={14} />
                        {i.label}
                      </NavLink>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            )
          })}
        </nav>
        <div className="border-t border-slate-200 px-3 py-2 text-2xs text-muted dark:border-slate-700">
          <div className="truncate font-medium text-default">Lender Hub</div>
          <div className="truncate">{window.location.host} · {apiMode() ? 'the Hub API' : 'fixtures (tests)'}</div>
        </div>
      </aside>
    </>
  )
}
